import React, { Component } from 'react';
import { Common } from '../../core/common';
import { MessagesService } from '../../api/message-services';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import imgError from '../../static/images/error.svg';

const T = Translator.create();
const _logger = Log.create('groupListItem.tsx');

let _common: Common;
const messagesService = new MessagesService();

export class ErrorPage extends Component<any, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public navigateUrl(address: string) {
      const url = window.appSettings.DEFAULT_URL + '/u/' + address;
      window.location.href = url;

  }

    public render() {
        return (
          <div>
            <div className="d-flex justify-content-center pt-5" >
                <div className='col-lg-12 justify-content-center text-center'>
                <img style={{ marginTop: '2em', marginBottom: '1em' }} src={imgError} />
                <br></br>
                <h5>{T.t('r_error_title')}</h5>
                
                { T.t('r_error_info') }
                </div>
            </div>

          <div className="d-flex justify-content-center pt-5" >
          <button className='alms-btn btn-default btn-icon' onClick={te => this.navigateUrl("Home/Index")}> { T.t('r_menu_home') } </button>

          </div>
    </div>        
        );
    }
}

export default ErrorPage;
